import { AddressFields } from 'ui-kit/form/interfaces/AddressModal';
import { CountryCode } from '@agentnet/utils';
import { TransfereeType } from '../constants';

export interface Transferee {
  transfereeType: TransfereeType;
  transfereeLegalName: string;
  transfereeDbaName?: string;
  noConsiderationPaid: boolean;
  totalConsideration: string;
  foreignBusinessNoUSLocation: boolean;
  addressType: string;
  primaryUSAddress?: AddressFields;
  foreignBusinessAddress?: AddressFields;
  foreignPrincipalAddress?: AddressFields;
  identificationType: string;
  identificationNumber: string;
  issuingJurisdiction: string;
  dateTrustExecuted: string;
  isRevocableTrust: boolean;
  parties: any[];
  status: string;
}

export const getInitialTransfereeData = (): Transferee => ({
  transfereeType: TransfereeType.ENTITY,
  transfereeLegalName: '',
  transfereeDbaName: '',
  noConsiderationPaid: false,
  totalConsideration: '',
  foreignBusinessNoUSLocation: false,
  addressType: '',
  primaryUSAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: CountryCode.US,
    postalCode: '',
  },
  foreignBusinessAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: CountryCode.US,
    postalCode: '',
  },
  foreignPrincipalAddress: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    country: CountryCode.US,
    postalCode: '',
  },
  identificationType: '',
  identificationNumber: '',
  issuingJurisdiction: '',
  dateTrustExecuted: '',
  isRevocableTrust: false,
  parties: [],
  status: 'incomplete',
});
